import React from 'react';
import { useQuery } from '@tanstack/react-query';

import type { OwnerDetail, UseQueryWrapper } from 'app/types';
import ownerService from '../../../Domain/Owners/Services/OwnerService';

import { useSnakeBar } from '../../useSnakeBar';

export type GetOwnerDetailQueryVariables = { ownerId: string | undefined };

export type GetOwnerDetailQueryResultData = OwnerDetail;

const queryFn =
  ({ ownerId }: GetOwnerDetailQueryVariables) =>
  async (): Promise<GetOwnerDetailQueryResultData> => {
    const response = await ownerService.getOwnerDetail(ownerId!);
    return response.data as OwnerDetail;
  };

const QUERY_KEY = 'getOwnerDetail';

export const useOwnerGetDetailQuery: UseQueryWrapper<GetOwnerDetailQueryResultData, GetOwnerDetailQueryVariables> = ({
  variables,
  options,
}) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<GetOwnerDetailQueryResultData>([QUERY_KEY, variables.ownerId], queryFn(variables), {
    onError,
    enabled: !!variables.ownerId,
    ...(options || {}),
  });
};
